import React from 'react';
import './ChordDisplay.css';

function ChordDisplay({ chord, isActive }) {
  // Common chord fingering data (guitar)
  const chordDiagrams = {
    // Major chords
    'C': { strings: ['x', '3', '2', '0', '1', '0'], frets: [0, 3, 5, 5, 5, 3], description: 'Major triad' },
    'D': { strings: ['x', 'x', '0', '2', '3', '2'], frets: [0, 0, 5, 7, 7, 7], description: 'Major triad' },
    'E': { strings: ['0', '2', '2', '1', '0', '0'], frets: [0, 2, 2, 1, 0, 0], description: 'Major triad' },
    'F': { strings: ['1', '3', '3', '2', '1', '1'], frets: [1, 3, 3, 2, 1, 1], description: 'Major triad' },
    'G': { strings: ['3', '2', '0', '0', '0', '3'], frets: [3, 2, 0, 0, 0, 3], description: 'Major triad' },
    'A': { strings: ['x', '0', '2', '2', '2', '0'], frets: [0, 0, 2, 2, 2, 0], description: 'Major triad' },
    'B': { strings: ['x', '2', '4', '4', '4', '2'], frets: [0, 2, 4, 4, 4, 2], description: 'Major triad' },
    
    // Flat major chords (flats correspond to half step higher notes)
    'Ab': { strings: ['4', '6', '6', '5', '4', '4'], frets: [4, 6, 6, 5, 4, 4], description: 'Major triad (G#)' },
    'Bb': { strings: ['x', '1', '3', '3', '3', '1'], frets: [0, 1, 3, 3, 3, 1], description: 'Major triad (A#)' },
    'Db': { strings: ['x', '4', '6', '6', '6', '4'], frets: [0, 4, 6, 6, 6, 4], description: 'Major triad (C#)' },
    'Eb': { strings: ['x', '6', '8', '8', '8', '6'], frets: [0, 6, 8, 8, 8, 6], description: 'Major triad (D#)' },
    'Gb': { strings: ['2', '4', '4', '3', '2', '2'], frets: [2, 4, 4, 3, 2, 2], description: 'Major triad (F#)' },
    
    // Sharp major chords (corresponding to flats)
    'G#': { strings: ['4', '6', '6', '5', '4', '4'], frets: [4, 6, 6, 5, 4, 4], description: 'Major triad (Ab)' },
    'A#': { strings: ['x', '1', '3', '3', '3', '1'], frets: [0, 1, 3, 3, 3, 1], description: 'Major triad (Bb)' },
    'C#': { strings: ['x', '4', '6', '6', '6', '4'], frets: [0, 4, 6, 6, 6, 4], description: 'Major triad (Db)' },
    'D#': { strings: ['x', '6', '8', '8', '8', '6'], frets: [0, 6, 8, 8, 8, 6], description: 'Major triad (Eb)' },
    'F#': { strings: ['2', '4', '4', '3', '2', '2'], frets: [2, 4, 4, 3, 2, 2], description: 'Major triad (Gb)' },
    
    // Minor chords
    'Cm': { strings: ['x', '3', '5', '5', '4', '3'], frets: [0, 3, 5, 5, 4, 3], description: 'Minor triad' },
    'Dm': { strings: ['x', 'x', '0', '2', '3', '1'], frets: [0, 0, 0, 2, 3, 1], description: 'Minor triad' },
    'Em': { strings: ['0', '2', '2', '0', '0', '0'], frets: [0, 2, 2, 0, 0, 0], description: 'Minor triad' },
    'Fm': { strings: ['1', '3', '3', '1', '1', '1'], frets: [1, 3, 3, 1, 1, 1], description: 'Minor triad' },
    'Gm': { strings: ['3', '5', '5', '3', '3', '3'], frets: [3, 5, 5, 3, 3, 3], description: 'Minor triad' },
    'Am': { strings: ['x', '0', '2', '2', '1', '0'], frets: [0, 0, 2, 2, 1, 0], description: 'Minor triad' },
    'Bm': { strings: ['x', '2', '4', '4', '3', '2'], frets: [0, 2, 4, 4, 3, 2], description: 'Minor triad' },
    
    // Flat minor chords
    'Abm': { strings: ['4', '6', '6', '4', '4', '4'], frets: [4, 6, 6, 4, 4, 4], description: 'Minor triad (G#m)' },
    'Bbm': { strings: ['x', '1', '3', '3', '2', '1'], frets: [0, 1, 3, 3, 2, 1], description: 'Minor triad (A#m)' },
    'Ebm': { strings: ['x', '6', '8', '8', '7', '6'], frets: [0, 6, 8, 8, 7, 6], description: 'Minor triad (D#m)' },
    
    // 7th chords
    'C7': { strings: ['x', '3', '2', '3', '1', '0'], frets: [0, 3, 2, 3, 1, 0], description: 'Dominant 7th' },
    'D7': { strings: ['x', 'x', '0', '2', '1', '2'], frets: [0, 0, 0, 2, 1, 2], description: 'Dominant 7th' },
    'E7': { strings: ['0', '2', '0', '1', '0', '0'], frets: [0, 2, 0, 1, 0, 0], description: 'Dominant 7th' },
    'F7': { strings: ['1', '3', '1', '2', '1', '1'], frets: [1, 3, 1, 2, 1, 1], description: 'Dominant 7th' },
    'G7': { strings: ['3', '2', '0', '0', '0', '1'], frets: [3, 2, 0, 0, 0, 1], description: 'Dominant 7th' },
    'A7': { strings: ['x', '0', '2', '0', '2', '0'], frets: [0, 0, 2, 0, 2, 0], description: 'Dominant 7th' },
    'B7': { strings: ['x', '2', '1', '2', '0', '2'], frets: [0, 2, 1, 2, 0, 2], description: 'Dominant 7th' },
    
    // Flat 7th chords
    'Ab7': { strings: ['4', '6', '4', '5', '4', '4'], frets: [4, 6, 4, 5, 4, 4], description: 'Dominant 7th (G#7)' },
    'Bb7': { strings: ['x', '1', '3', '1', '3', '1'], frets: [0, 1, 3, 1, 3, 1], description: 'Dominant 7th (A#7)' },
    'Eb7': { strings: ['x', '6', '5', '6', '5', '6'], frets: [0, 6, 5, 6, 5, 6], description: 'Dominant 7th (D#7)' }
  };

  // Default fingering (if no matching chord is found)
  const defaultDiagram = { strings: ['x', 'x', 'x', 'x', 'x', 'x'], frets: [0, 0, 0, 0, 0, 0], description: 'Undefined chord' };

  // Chord equivalence mapping (handling sharps and flats)
  const chordEquivalents = {
    'Ab': 'G#', 'Bb': 'A#', 'Cb': 'B', 'Db': 'C#', 'Eb': 'D#', 'Fb': 'E', 'Gb': 'F#',
    'G#': 'Ab', 'A#': 'Bb', 'B#': 'C', 'C#': 'Db', 'D#': 'Eb', 'E#': 'F', 'F#': 'Gb',
    'Abm': 'G#m', 'Bbm': 'A#m', 'Dbm': 'C#m', 'Ebm': 'D#m', 'Gbm': 'F#m',
    'G#m': 'Abm', 'A#m': 'Bbm', 'C#m': 'Dbm', 'D#m': 'Ebm', 'F#m': 'Gbm',
    'Ab7': 'G#7', 'Bb7': 'A#7', 'Db7': 'C#7', 'Eb7': 'D#7', 'Gb7': 'F#7',
    'G#7': 'Ab7', 'A#7': 'Bb7', 'C#7': 'Db7', 'D#7': 'Eb7', 'F#7': 'Gb7'
  };

  // Get chord fingering
  const getChordDiagram = (chordName) => {
    // Check if there's a direct match
    if (chordDiagrams[chordName]) {
      return chordDiagrams[chordName];
    }
    
    // Check if there's an equivalent chord 
    const equivalent = chordEquivalents[chordName];
    if (equivalent && chordDiagrams[equivalent]) {
      return chordDiagrams[equivalent];
    }
    
    // Try to parse chord structure
    // Base chord (first character, could be A-G)
    let baseNote = chordName.charAt(0);
    let remainder = chordName.substring(1);
    
    // Check if there's a sharp or flat
    if (remainder.startsWith('b') || remainder.startsWith('#')) {
      baseNote += remainder.charAt(0);
      remainder = remainder.substring(1);
    }
    
    // Check if it's a minor
    const isMinor = remainder.includes('m') && !remainder.includes('maj');
    
    // Check if it's a seventh chord
    const isSeventh = remainder.includes('7');
    
    // Build lookup key
    let lookupKey = baseNote;
    if (isMinor) lookupKey += 'm';
    if (isSeventh) lookupKey += '7';
    
    // Final check
    if (chordDiagrams[lookupKey]) {
      return chordDiagrams[lookupKey];
    }
    
    // Try using equivalent chord
    if (chordEquivalents[lookupKey] && chordDiagrams[chordEquivalents[lookupKey]]) {
      return chordDiagrams[chordEquivalents[lookupKey]];
    }
    
    // No match found, return default
    return defaultDiagram;
  };

  // Render chord diagram
  const renderChordDiagram = (chordName) => {
    const diagram = getChordDiagram(chordName);
    
    return (
      <div className="chord-diagram">
        <div className="chord-name">{chordName}</div>
        <div className="guitar-chord">
          <div className="guitar-strings">
            {diagram.strings.map((finger, index) => (
              <div key={index} className="string">
                <div className="string-name">{6-index}</div>
                <div className="string-line"></div>
                <div className="finger">{finger}</div>
              </div>
            ))}
          </div>
          <div className="chord-description">{diagram.description}</div>
        </div>
      </div>
    );
  };

  return (
    <div className={`chord-display ${isActive ? 'active' : ''}`}>
      {renderChordDiagram(chord)}
    </div>
  );
}

export default ChordDisplay; 